const _ = require("lodash");
const setIn = require("../ImmHelpers").setIn;

const settings = {
	staticMaxStars: true,
	canEarnStarsOnTrialSubmission: true,

	neverShowSliderMessages: true,

	neverResumeResult: true,
	updatePercentCompleteOnStateChange: true,
	canFinishOnStateChange: true,
	noUndoRedoClear: true,
	neverSetOutcome: true,
	saveAllProblems: true,

	noProblemHistory: true,
	skipProblemCount: true,
};

const initialize = function(result, processor) {
	const currentProblem = result.problems[0];
	currentProblem.customState = processor.setupCustomState(
		currentProblem.model,
		currentProblem.customState
	);
};

const computeBackendProgress = function(result, defaultProgress) {
	return _.extend({}, defaultProgress, {
		problems: defaultProgress.problems.map((p, i) =>
			_.extend(
				{
					problemBatex: result.problems[i].model.problems,
				},
				setIn(p, "customState", _.omit(p.customState, ["solutionBatex"]))
			)
		),
	});
};

const computeBackendTrial = function(result, problem, backendTrial) {
	const trialData = backendTrial.response.response;

	const [problemIndex, response] = trialData;
	const problemData = problem.model.problems[problemIndex];
	const [problemBatex, answer] = problemData;

	return _.extend({}, backendTrial, {
		response: {response},
		problemData: {
			problemBatex,
			answer,
		},
		final: true,
		attemptNumber: 1,
	});
};

const getStars = function(result) {
	// 100% => 3 stars
	// 90% => 2 stars
	// 80% => 1 star
	const numCorrect = getNumCorrect(result);
	const totalProblems = getNumProblems(result);
	const percentCorrect = numCorrect / totalProblems;
	if (percentCorrect >= 1) return 3;
	if (percentCorrect >= 0.9) return 2;
	if (percentCorrect >= 0.8) return 1;
	return 0;
};

const getPercentComplete = function(result) {
	const numProblemsLeft = getNumProblemsLeft(result);
	const totalProblems = getNumProblems(result);
	return 1 - numProblemsLeft / totalProblems;
};

const canGoToNextProblem = function(result) {
	return true;
};

const getTrialXP = function(result) {
	return 1;
};

const isCurrentProblemDone = function(result) {
	return isFinished(result);
};

const isFinished = function(result) {
	const currentProblem = result.problems[0];
	// end if there are no more problems left
	return currentProblem.customState.numProblemsLeft === 0;
};

const getResultProgressXP = function(backendResult) {
	const {progress} = backendResult;
	const numCorrect = _.get(progress, "problems.0.customState.numCorrect") || 0;
	return numCorrect * getTrialXP();
};

const processPostSubmission = function(result, processor) {
	const currentProblem = result.problems[0];
	const problemModel = currentProblem.model;
	const customState = currentProblem.customState;
	const newCustomState = processor.updateCustomState(
		problemModel,
		customState,
		currentProblem.trials
	);
	return setIn(result, ["problems", 0, "customState"], newCustomState);
};

const getNumCorrect = function(result) {
	const currentProblem = result.problems[0];
	return currentProblem.customState.numCorrect;
};

const getNumProblems = function(result) {
	const currentProblem = result.problems[0];
	return currentProblem.customState.totalProblems;
};

const getNumProblemsLeft = function(result) {
	const currentProblem = result.problems[0];
	return currentProblem.customState.numProblemsLeft;
};

const getStarProgressInfo = function(result) {
	const starCutoffs = [1, 0.9, 0.8];
	const numCorrect = getNumCorrect(result);
	const numProblems = getNumProblems(result);
	return {
		styleType: result.styleType,
		filledAmount: numCorrect / numProblems,
		totalAmount: 1,
		allCutoffs: starCutoffs,
		starCutoffs,
		keepStarsReached: true,
	};
};

const getSummaryForReport = function(backendResult) {
	const customState = _.get(backendResult, "progress.problems[0].customState");
	if (!customState) {
		return "Problems cannot be displayed for this game lesson.";
	} else {
		return `${customState.numCorrect || 0} / ${customState.totalProblems ||
			0} problems answered correctly.`;
	}
};

module.exports = {
	settings,
	computeBackendProgress,
	computeBackendTrial,
	initialize,
	isCurrentProblemDone,
	canGoToNextProblem,
	getStars,
	getPercentComplete,
	isFinished,
	getResultProgressXP,
	processPostSubmission,
	getNumCorrect,
	getNumProblems,
	getNumProblemsLeft,
	getTrialXP,
	getStarProgressInfo,
	getSummaryForReport,
};
